import Vue from "vue";

export const IDLE_TIME_MILLISECONDS = 900000;
export const IDLE_TIME_WARNING_SECONDS = 10;

const eventsHub = new Vue();

export default {
    idleTime: IDLE_TIME_MILLISECONDS,
    startAtIdle: false,
    eventEmitter: eventsHub,
};
